import { useAemConfig } from '@as-react/common-components';

import { ClientData, DefaultBodyType, DefaultErrorType, FetchOptions, queryFn } from './queryFetch.utils';

export type CustomClient<T> = (data: ClientData, options: FetchOptions) => Promise<T>;

export const useQueryFetch = <T>(): CustomClient<T> => {
  const { servicesEndpoint } = useAemConfig();
  return (data, options) => queryFn<T>(data, options, servicesEndpoint);
};

export type ErrorType<ErrorData> = DefaultErrorType<ErrorData>;
export type BodyType<BodyData> = DefaultBodyType<BodyData>;
